package services.storage.http

import it.neckar.lizergy.model.price.AvailableProducts
import it.neckar.lizergy.model.price.PriceList
import it.neckar.lizergy.model.price.ProductResolver
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


/**
 * Response for
 */
@Serializable
sealed interface FetchStaticPriceListResponse : RestResponse<FetchStaticPriceListInformation> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: FetchStaticPriceListInformation) : FetchStaticPriceListResponse, RestResponse.GoodResponse<FetchStaticPriceListInformation>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchStaticPriceListResponse, RestResponse.BadResponse<FetchStaticPriceListInformation>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: FetchStaticPriceListInformation): FetchStaticPriceListResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): FetchStaticPriceListResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: FetchStaticPriceListInformation?): FetchStaticPriceListResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}

@Serializable
data class FetchStaticPriceListInformation(
  val availableProducts: AvailableProducts,
  val productResolver: ProductResolver,
  val priceList: PriceList,
)
